import { createMuiTheme } from '@material-ui/core/styles';
import { deepmerge } from '@material-ui/utils';
import sharedProps from '../shared/props';
import sharedOverrides from '../shared/overrides';
import sharedShadows from '../shared/shadows';
import palette from './palette';
import marketingOverrides from './overrides';
import typography from './typography';
var defaultTheme = createMuiTheme();
var marketingTheme = createMuiTheme({
  palette: palette,
  props: sharedProps,
  typography: typography(defaultTheme)
});
marketingTheme.shadows = sharedShadows(marketingTheme.palette.grey[100]);
marketingTheme.overrides = deepmerge(sharedOverrides(marketingTheme), marketingOverrides);
export default marketingTheme;